<template>
  <div>
    <ParentBar />
    <PermissionValidation :marketId="marketId" rule="enableViewIncomeExpense">
      <layout :isSuccess="true">
        <template v-slot:containerZone>
          <div class="my-4 non-print">
            <v-row class="bg-white mx-0">
              <v-col cols="12" class="text-center">
                <h1>{{ $t('payment.income_and_expense') }}</h1>
              </v-col>
              <v-col cols="10">
                <v-row>
                  <v-col cols="6">
                    <v-menu v-model="menuStartDate" :close-on-content-click="false" transition="scale-transition" offset-y
                      max-width="290px" min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="$helper.datelabel(formData.startDate)" :placeholder="$t('date')" outlined dense
                          hide-details readonly v-bind="attrs" v-on="on" :label="$t('from_date')"></v-text-field>
                      </template>
                      <v-date-picker v-model="formData.startDate" no-title locale="th" @input="menuStartDate = false"
                        :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                        :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6">
                    <v-menu v-model="menuEndDate" :close-on-content-click="false" transition="scale-transition" offset-y
                      max-width="290px" min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="$helper.datelabel(formData.endDate)" :placeholder="$t('date')" outlined dense
                          hide-details readonly v-bind="attrs" v-on="on" :label="$t('to_date')"></v-text-field>
                      </template>
                      <v-date-picker v-model="formData.endDate" no-title locale="th" @input="menuEndDate = false"
                        :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                        :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="2" class="text-center">
                <v-btn @click="initData()" class="primary" block :disabled="isLoading">
                  <v-icon>mdi-magnify</v-icon>{{ $t('search') }}
                </v-btn>
              </v-col>
              <v-col cols="12" class="text-center pt-5 pb-4 grey lighten-4">
                <h2>
                  <b>{{ $t('date_list') }}</b>
                  {{ $helper.datelabel(tempDate.startDate) }} -
                  {{ $helper.datelabel(tempDate.endDate) }}
                </h2>

              </v-col>

              <v-col cols="12" class="px-0 pt-0 pb-4" id="printarea">
                <v-row class="mb-1">
                  <v-col cols="12" class="card-layout">
                    <div class="card-summary" v-for="currency in $helper.currencyOptions.filter(c => c.value == $globalCurrencyCode)" :key="currency.name">
                      <div class="card-header">
                        {{ $t('market.income_expense') }} <span>({{ currency.tabName }})</span>
                      </div>
                      <div class="card-body">
                        <div class="card-row">
                          <div class="card-text">
                            <img src="@/assets/icons/income-profit-up.svg" alt="income-profit-up" class="me-2">
                            {{ $t('payment.all_income') }}
                          </div>
                          <div class="card-number number-income">
                            <v-progress-circular v-if="isLoadingSummary" indeterminate size="24" color="green"></v-progress-circular>
                            <div v-else>{{ getSummary(currency.value).income | currencySuffixTextThEn(currency.value) }}</div>
                          </div>
                        </div>
                        <div class="card-row sec">
                          <div class="card-text">
                            <img src="@/assets/icons/income-profit-down.svg" alt="income-profit-down" class="me-2">
                            {{ $t('payment.all_expense') }}
                          </div>
                          <div class="card-number number-expense">
                            <v-progress-circular v-if="isLoadingSummary" indeterminate size="24" color="red"></v-progress-circular>
                            <div v-else>{{ getSummary(currency.value).expense | currencySuffixTextThEn(currency.value) }}</div>
                          </div>
                        </div>
                      </div>
                      <v-divider class="line-grey"></v-divider>
                      <div class="card-body">
                        <div class="card-row">
                          <div class="card-text total">{{ $t('market.summary_of_profit_and_loss') }}</div>
                          <div v-if="isLoadingSummary" class="card-number number-income">
                            <v-progress-circular indeterminate size="24" color="green"></v-progress-circular>
                          </div>
                          <template v-else>
                            <div class="card-number  number-income" v-if="(getSummary(currency.value).income + getSummary(currency.value).expense) > 0">
                            {{ (getSummary(currency.value).income + getSummary(currency.value).expense) | currencySuffixTextThEn(currency.value) }}</div>
                          <div class="card-number number-expense" v-else-if="(getSummary(currency.value).income + getSummary(currency.value).expense) < 0">
                            {{ (getSummary(currency.value).income + getSummary(currency.value).expense) | currencySuffixTextThEn(currency.value) }}</div>
                            <div class="card-number" v-else>{{ (getSummary(currency.value).income + getSummary(currency.value).expense) | currencySuffixTextThEn(currency.value) }}</div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="d-flex align-end pb-10 menu-export">
                    <div class="non-print">
                      <v-btn @click="exportExcel()" class="blue white--text" :disabled="isLoading || isDownloading">
                        <v-icon class="me-2">mdi-file-excel-outline</v-icon>Export Excel
                      </v-btn>
                      <v-btn class="blue white--text mx-1" @click="printPDF()" :disabled="isLoading || isDownloading">
                        <v-icon left>mdi-file-excel</v-icon>{{ $t('print_pdf') }}
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="6" class="menu-export pb-10">
                    <div class="non-print">
                      <div class="d-flex justify-end gap-2">
                        <v-btn @click="openExpenseDialog()" class="bg-white" :disabled="isLoading || isDownloading">
                          <img src="@/assets/icons/income-profit-down.svg" alt="income-profit-down" class="me-2">
                          {{ $t('payment.add_expense') }}
                        </v-btn>
                        <v-btn @click="openIncomeDialog()" :disabled="isLoading || isDownloading" class="bg-white">
                          <img src="@/assets/icons/income-profit-up.svg" alt="income-profit-up" class="me-2">
                          {{ $t('payment.add_income') }}
                        </v-btn>
                        <v-btn @click="isCategoryListDialog = true" class="bg-white" :disabled="isLoading || isDownloading">
                          <v-icon class="me-2">mdi-format-list-bulleted-square</v-icon>{{ $t('project.manage_category') }}
                        </v-btn>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <template v-if="!isFirstLoading">
                  <v-data-table
                    v-if="dataTable && dataTable.data"
                    :headers="dataTable.headers"
                    :items="dataTable.data"
                    :items-per-page="10"
                    class="elevation-1 table-report-checkout v-data-table-report"
                    item-key="objectId"
                    ref="dataTableIncomeExpense"
                    @click:row="rowClick"
                    :loading="isLoading"
                    :footer-props="{
                      'items-per-page-options': itemsPerPageOptions,
                    }"
                    :no-data-text="$t('noinfo')"
                    :no-results-text="$t('no_matching_records_found')"
                  >

                    <template v-slot:header.detail="{header}">
                      <div class="text-nowrap-table text-center" style="min-width:250px;width:250px;">{{header.text}}</div>
                    </template>
                    <template v-slot:header.category="{header}">
                      <div class="text-nowrap-table text-center" style="min-width:190px">{{header.text}}</div>
                    </template>
                    <template v-slot:header.createdByText="{header}">
                      <div class="text-nowrap-table text-center" style="min-width:190px;">{{header.text}}</div>
                    </template>

                    <template v-slot:item.date="{ item }">
                      <template v-if="item.date" class="text-center">{{ $moment(item.date).format("DD/MM/YYYY") }}</template>
                    </template>
                    <template v-slot:item.detail="{ item }">
                      <div class="text-truncate detail text-center">{{ item.detail }}</div>
                    </template>
                    <template v-slot:item.category="{ item }">
                      <div class="text-truncate text-center customer">
                        {{ item.category }}
                        <div v-if="(item.type == 'expense' || item.type == 'income') && item.categoryItem && item.categoryItem.isRemoved" style="display: inline;">
                          <v-chip small color="red" outlined>{{ $t('payment.category_deleted') }}</v-chip>
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.totalValue="{ item }">
                      <span class="red--text" v-if="item.totalValue < 0">{{ item.totalValue | currencyPrefixSign(item.currencyCode)  }}</span>
                      <span class="success--text" v-else-if="item.totalValue > 0">{{ item.totalValue | currencyPrefixSign(item.currencyCode)  }}</span>
                      <span style="color: #92949c;" v-else>{{ item.totalValue | currencyPrefixSign(item.currencyCode)  }}</span>
                    </template>
                    <template v-slot:item.createdByText="{ item }">
                      <div class="text-truncate text-center customer">{{ item.createdByText }}</div>
                    </template>
                    <template v-slot:body.prepend>
                      <tr class="non-print">
                        <td class="text-center">
                          <v-icon>mdi-filter-multiple-outline</v-icon>
                        </td>
                        <td class="ps-0">
                          <v-text-field v-model="filterData.documentId" type="text" :label="$t('market.document_id')" solo dense
                            hide-details />
                        </td>
                        <td class="ps-0">
                          <v-text-field v-model="filterData.detail" type="text" :label="$t('detail')" solo dense
                            hide-details />
                        </td>
                        <td class="ps-0">
                          <v-text-field v-model="filterData.contractId" type="text" :label="$t('contract.contract_number_only')" solo dense
                            hide-details />
                        </td>
                        <td class="ps-0">
                          <v-text-field v-model="filterData.category" type="text" :label="$t('category')" solo dense
                            hide-details />
                        </td>
                        <td class="ps-0">
                          <v-text-field v-model="filterData.totalValue" type="text" :label="$t('market.total_value')" solo dense
                            hide-details />
                        </td>
                        <td class="ps-0">
                          <v-text-field v-model="filterData.createdByText" type="text" :label="$t('operator')" solo dense
                            hide-details />
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </template>
                <v-col v-else cols="12">
                  <v-card class="d-flex justify-center py-10" elevation="0">
                    <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
                  </v-card>
                </v-col>
              </v-col>
            </v-row>
          </div>
        </template>
      </layout>
      <v-snackbar v-model="isError" color="error" top>
        <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
      </v-snackbar>
      <ExpenseDialog v-model="isExpenseDialog" :marketId="marketId" :projectId="projectId" :expense="tempExpense"
        @onSaveSuccess="onIncomeExpense" />
      <IncomeDialog v-model="isIncomeDialog" :marketId="marketId" :projectId="projectId" :income="tempIncome"
        @onSaveSuccess="onIncomeExpense" />
      <TransactionCategoryListDialog v-model="isCategoryListDialog" :projectId="projectId" />
      <ReceiptDialog v-if="tempReceipt" v-model="isReceiptDialog" :receiptId="tempReceipt.objectId"
        :projectId="projectId" />
      <CreditNoteDialog v-if="tempCreditNote" v-model="isCreditNoteDialog" :creditNoteId="tempCreditNote.objectId"
        :projectId="projectId" />
    </PermissionValidation>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ExportIncomeExpense } from "../../exports";
import { IncomeExpense } from "../../classes";

import ParentBar from "@/components/ParentBar.vue";
import Layout from "@/components/Layout.vue";
import SelectMonthYear from "@/components/SelectMonthYear.component";
import ExpenseDialog from "@/components/ExpenseDialog";
import IncomeDialog from "@/components/IncomeDialog";
import ReceiptDialog from "@/components/ReceiptDialog.component.vue";
import TransactionCategoryListDialog from "@/components/TransactionCategoryListDialog";
import CreditNoteDialog from "@/components/CreditNoteDialog.component.vue";
import PermissionValidation from "@/components/PermissionValidation.component.vue";

export default {
  components: {
    SelectMonthYear,
    ParentBar,
    Layout,
    ExpenseDialog,
    ReceiptDialog,
    TransactionCategoryListDialog,
    IncomeDialog,
    CreditNoteDialog,
    PermissionValidation
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      project: null,
      market: null,
      selectedMonthYear: null,
      isError: false,
      isLoading: false,
      isFirstLoading: false,
      isLoadingSummary: false,
      menuStartDate: false,
      menuEndDate: false,
      formData: {
        startDate: this.$moment({ day: 1 }).format("YYYY-MM-DD"),
        endDate: this.$moment()
          .endOf("month")
          .format("YYYY-MM-DD")
      },
      tempDate: null,
      isDownloading: false,
      isExpenseDialog: false,
      isReceiptDialog: false,
      isIncomeDialog: false,
      isCreditNoteDialog: false,
      isCategoryListDialog: false,
      filterData: {
        documentId: null,
        detail: null,
        contractId: null,
        category: null,
        totalValue: null,
        createdByText: null,
      },
      tempExpense: null,
      tempReceipt: null,
      tempIncome: null,
      tempCreditNote: null,
      summary: {},
      itemsPerPage: 20,
      itemsPerPageOptions: [10, 20, 50, 100],
    };
  },
  watch: {
    filterData: {
      handler(val) {
        this.calSummary()
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters({
      incomeExpenses: "incomeExpense/getIncomeExpenses",
      getFullName: "user/getFullName",
      getAdminByMarketId: "admin/getByMarketId",
      getEmployeeByMarketId: "employee/getByMarketId",
      getLastCurrencyRate: "currencyRate/getLastCurrencyRate",
    }),
    userFullName() {
      return this.getFullName;
    },
    admin() {
      return this.getAdminByMarketId(this.marketId);
    },
    employee() {
      return this.getEmployeeByMarketId(this.marketId);
    },
    css_media_style() { // creates a CSS <style> and returns it
      const style = document.createElement("style");
      document.head.appendChild(style);
      return style;
    },
    dataTable() {
      return {
        headers: [
          {
            text: this.$t('date'),
            value: "date",
            width: "7%"
          },
          {
            text: this.$t('market.document_id'),
            value: "documentId",
            align: "center",
            width: "13%",
            filter: d =>
              this.filterData.documentId
                ? d.toLowerCase().includes(this.filterData.documentId.toLowerCase())
                : d
          },
          {
            text: this.$t('detail'),
            value: "detail",
            align: "center hd-resize",
            width: "1%",
            sortable : false,
            filter: d =>
              this.filterData.detail
                ? d.toLowerCase().includes(this.filterData.detail.toLowerCase())
                : d
          },
          {
            text: this.$t('contract.contract_number_only'),
            value: "contractId",
            align: "center",
            width: "13%",
            filter: d =>
              this.filterData.contractId
                ? d.toLowerCase().includes(this.filterData.contractId.toLowerCase())
                : d
          },
          {
            text: this.$t('category'),
            value: "category",
            align: "center hd-resize",
            width: "1%",
            sortable : false,
            filter: d =>
              this.filterData.category
                ? d.toLowerCase().includes(this.filterData.category.toLowerCase())
                : d
          },
          {
            text: this.$t('market.total_value'),
            value: "totalValue",
            width: "10%",
            align: "right",
            filter: d =>
              this.filterData.totalValue
                ? d.toString().includes(this.filterData.totalValue)
                : d || d === 0
          },
          {
            text: this.$t('operator'),
            width: "1%",
            value: "createdByText",
            align: "center hd-resize",
            sortable : false,
            filter: d =>
              this.filterData.createdByText
                ? d.toLowerCase().includes(this.filterData.createdByText.toLowerCase())
                : d
          }
        ],
        data: this.incomeExpenses || []
      };
    },
    isCurrencySupport(){
      return this.$helper.currencyOptions.length > 1
    },
  },
  async created() {
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }
    this.initData();
  },
  mounted() {
    this.css_media_style.innerHTML = "@media print { @page { size: A4 portrait; margin: 38px !important; } * { font-family: 'Sarabun' !important; } }";
  },
  methods: {
    async initData() {
      this.isLoading = true;
      this.isFirstLoading = true;
      this.summary = {}
      try {
        this.tempDate = JSON.parse(JSON.stringify(this.formData));
        let params = {
          marketId: this.marketId,
          startDate: this.$moment(this.formData.startDate)
            .startOf("day")
            .toISOString(),
          endDate: this.$moment(this.formData.endDate)
            .endOf("day")
            .toISOString()
        }
        this.initSummary(params)
        this.$store.commit("incomeExpense/setIncomeExpenses", [])
        await IncomeExpense.getIncomeExpenseBetweenDateByMarket(params, (results) => {
          if (results.length) {
            this.$store.commit("incomeExpense/addIncomeExpenses", results);
            this.isFirstLoading = false;
          }
        })
        setTimeout(() => {
          this.calSummary()
        }, 100);
        this.isLoading = false;
        this.isFirstLoading = false;
      } catch (error) {
        console.error(error);
        this.isLoading = false;
        this.isFirstLoading = false;
        this.isError = true;
      }
    },
    async initSummary(params) {
      this.isLoadingSummary = true
      try {
        let hashSummary = await this.$store.dispatch("income/getIncomeExpenseSummaryByMarket", params)
        for (let { value } of this.$helper.currencyOptions) {
          this.summary[value] = hashSummary[value] || { income: 0, expense: 0 }
        }
        this.isLoadingSummary = false
      } catch (error) {
        console.error(error);
        this.isLoadingSummary = false
        throw error
      }
    },
    onIncomeExpense() {
      this.$nextTick(() => {
        this.calSummary()
      })
    },
    openExpenseDialog() {
      this.tempExpense = null
      this.isExpenseDialog = true
    },
    openIncomeDialog() {
      this.tempIncome = null
      this.isIncomeDialog = true
    },
    rowClick(data) {
      this.tempExpense = null
      this.tempReceipt = null
      if (data.type == "expense") {
        this.tempExpense = data.expense
        this.isExpenseDialog = true
      } else if (data.type == "receipt") {
        this.tempReceipt = data.receipt
        this.isReceiptDialog = true
      } else if (data.type == "income") {
        this.tempIncome = data.income
        this.isIncomeDialog = true
      } else if (data.type == "credit-note") {
        this.tempCreditNote = data.creditNote
        this.isCreditNoteDialog = true
      }
    },
    calSummary() {
      const newSummary = {}
      for (let { value } of this.$helper.currencyOptions) {
        newSummary[value] = { income: 0, expense: 0 }
      }
      if (this.$refs.dataTableIncomeExpense) {
        let incomeExpenses = this.$refs.dataTableIncomeExpense.$children[0].filteredItems
        for (let incomeExpense of incomeExpenses) {
          if (incomeExpense.totalValue > 0) {
            newSummary[incomeExpense.currencyCode].income += incomeExpense.totalValue
          } else {
            newSummary[incomeExpense.currencyCode].expense += incomeExpense.totalValue
          }
        }
      }
      this.summary = newSummary
    },
    exportExcel() {
      try {
        let incomeExpenses = this.$refs.dataTableIncomeExpense.$children[0].filteredItems
        ExportIncomeExpense.exportIncomeExpense(
          incomeExpenses,
          this.formData.startDate,
          this.formData.endDate,
          this.summary
        );
      } catch (err) {
        this.isError = true;
      }
    },
    printPDF() {
      const tempItemsPerPage = this.itemsPerPage
      const tempItemsPerPageOptions = this.itemsPerPageOptions
      this.itemsPerPageOptions = [-1]
      this.itemsPerPage = -1
      setTimeout(() => {
        let printarea = document.getElementById("printarea").innerHTML;
        let printPreviewTopic = document.getElementById("print-preview-topic");
        let printPreviewcontent = document.getElementById("print-preview-content");
        let printPreviewFooter = document.getElementById("print-preview-footer");

        printPreviewTopic.innerHTML = `
          <h2 style="text-align: center;" class="my-4">
            <b>${this.$t('payment.income_and_expense')}</b>
          </h2>
          <p style="text-align: center;">${this.market.name}</p>
          <p style="text-align: center;">
            ${this.$moment(this.formData.startDate, "YYYY-MM-DD").format("D MMMM YYYY")} - ${this.$moment(this.formData.endDate, "YYYY-MM-DD").format("D MMMM YYYY")}
          </p>
        `;
        printPreviewcontent.innerHTML = printarea;
        printPreviewFooter.innerHTML = `<div style="text-align: right;"><b>${this.$t('print_by')}</b> : ${this.userFullName} <b>${this.$t('at')}</b> ${this.$moment().format("lll")}</div>`;
        window.print();
        this.itemsPerPage = tempItemsPerPage
        this.itemsPerPageOptions = tempItemsPerPageOptions
      }, 200)
    },
    currencyRate(currency){
      let currencyRate = this.getLastCurrencyRate || {}
      let data = currencyRate?.data?.[currency] || {}
      if (data) {
        if(currency == 'THB'){
          return `≈ ${this.toExchangeRate(data["LAK"]?.value)} LAK | ≈ ${this.toExchangeRate(data["USD"]?.value)} USD`
        }else if(currency == 'USD'){
          return `≈ ${this.toExchangeRate(data["LAK"]?.value)} LAK | ≈ ${this.toExchangeRate(data["THB"]?.value)} THB`
        }else if(currency == 'LAK'){ 
          return `≈ ${this.toExchangeRate(data["USD"]?.value)} USD | ≈ ${this.toExchangeRate(data["THB"]?.value)} THB`
        }
      }
      return ""
    },
    toExchangeRate(val){
      return this.$helper.toCurrency(val, null, { isExchangeRate: true })
    },
    getSummary(currency) {
      return this.summary[currency] || { income: 0, expense: 0 }
    }
  }
};
</script>

<style lang="scss" scoped>
.total-header {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 15px;
}

.total-detail {
  font-size: 16px;

  .text-name {
    min-width: 200px;
    display: inline-block;
    font-weight: bold;
    padding-left: 10px;
  }

  .text-name-bank {
    min-width: 400px;
    display: inline-block;
    font-weight: bold;
    padding-left: 10px;
  }

  .text-bath {
    min-width: 150px;
    display: inline-block;
    text-align: right;
  }
}

.text-nowrap-table.detail,
.text-nowrap-table.customer {
  // width: 27%;
  min-width: 100%;
}

#printarea {
  background: #f5f5f5;
}

.menu-export {
  position: relative;
}

.card-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 10px;
  flex-wrap: wrap;
  .card-summary {
    margin: 5px 0 15px;
    background: #FFFFFF;
    border-radius: 15px;
    padding: 15px;
    min-width: 460px;
    font-size: 20px;
    max-width: 460px;
    width: 100%;
    .card-header {
      font-size: 20px;
      font-weight: bold;
      border-bottom: 1px solid #e5e5e5;
      padding-bottom: 10px;
    }
    .card-body{
      padding: 10px;
    }
    .card-row {
      display: flex;
      justify-content: space-between;
      .v-icon {
        font-size: 30px;
      }
      .card-text{
        display: flex;
        align-items: center;
        &.total {
          padding-left: 45px;
          font-size: 22px;
        }
      }

      .card-number.number-income {
        color: var(--v-success-base);
      }

      .card-number.number-expense {
        color: var(--v-error-base);
      }

    }
    .txt-currency-rate{
      font-size: 12px;
      color: #A9A9A9;
      line-height: 1;
      text-align: right;
      margin-bottom: 4px;
    }
  }
}

.line-grey{
  border-top: 3px solid #e5e5e5;
}
.v-data-table-report::v-deep td.hd-resize{
  max-width: 200px;
}
.v-data-table-report::v-deep td.hd-resize.detail{
  max-width: 250px;
}


</style>